module.exports = __webpack_public_path__ + "f3817a3973d131167ba95f441df41348.mp4";